import {useCallback} from 'react';
import {useSelector, useStore} from 'react-redux';
import {OptionToggle} from '~/CreateFabricInvitation/components/OptionToggle';
import {eventInEditMode, selectRsvpOff} from '~/CreateFabricInvitation/reducers/details/selectors';
import {selectRsvpOptional} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {IconWithBadge} from '~/common/components/IconWithBadge/IconWithBadge';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {SET_GUEST_OPTIONS} from '~/common/fabric/reducers/guestOptions/constants';
import {CREATE_EDIT_POLL} from '~/common/fabric/reducers/widgets';
import {InboxIcon} from '~library/svg/InboxIcon';
import {InformationFillIcon} from '~library/svg/InformationFillIcon';
import {aquamarine} from '~libSass/base/_exports.sass';

export const Rsvps = ({description}) => {
  const store = useStore();

  const rsvpOptional = useSelector(selectRsvpOptional);
  const rsvpOff = useSelector(selectRsvpOff);
  const inEditMode = useSelector(eventInEditMode);

  const handleChange = useCallback(() => {
    if (rsvpOff) {
      store.dispatch({
        type: SET_GUEST_OPTIONS,
        payload: {
          allowBringPeople: true,
          limitPerGuest: 9,
          allowMaybeRSVPs: true,
        },
      });
    }

    store.dispatch({
      type: UPDATE_EVENT_DETAILS,
      // biome-ignore lint/style/useNamingConvention: existing error
      payload: {rsvp_off: !rsvpOff},
    });
    if (!rsvpOff) {
      // If turning off RSVPs, clear any existing poll data
      store.dispatch({type: CREATE_EDIT_POLL, payload: {polls: []}});
    }
  }, [rsvpOff, store]);

  if (!rsvpOptional || inEditMode) {
    return null;
  }

  return (
    <OptionToggle
      dataQaId="request-rsvps-toggle"
      className="request-rsvps-toggle"
      checked={!rsvpOff}
      icon={<IconWithBadge mainIcon={<InboxIcon />} />}
      heading="Request RSVPs"
      description={
        <>
          {description}
          <br />
          <span className="request-rsvps-toggle-info">
            <InformationFillIcon ratio={0.5} color={aquamarine} />
            {`Can't adjust after sending.`}
          </span>
        </>
      }
      onChange={handleChange}
    />
  );
};
